<template>
  <tr>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-indigo-600 hover:underline">
        <button @click="toDriverForm()">{{ fullName }}</button>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ driver.user.email }}</div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ statusString(driver.validated) }}</div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ activeString(driver.active) }}</div>
    </td>
    <td v-if="showInternalData" class="px-2 py-2 whitespace-nowrap">
      <div v-if="showInternalData" class="text-sm text-gray-900">{{ driver.user.user_id }}</div>
    </td>
    <td v-if="showInternalData" class="px-2 py-2 whitespace-nowrap">
      <div v-if="showInternalData" class="text-sm text-gray-900">{{ driver.user.auth0_id }}</div>
    </td>
    <td v-if="showInternalData" class="px-2 py-2 whitespace-nowrap">
      <div class="flex flex-col">
        <div class="text-sm text-gray-900">{{ vendorDisplay }}</div>
        <div class="pl-2 text-sm w-48 text-gray-500">{{ driver.vendor.partition.description }}</div>
      </div>
    </td>
    <td>
      <!-- data-testid added for testing because there is no text identifier -->
      <DriverActions
        class="z-30 float-right pr-2"
        :data-testid="'driver-actions-dropdown-'+driver.id"
        :additionalActions="additionalActions"
        :driver="driver">
         <img class="min-w-[30px] min-h-[30px]" src="@/assets/icons/Options.svg">
      </DriverActions>
    </td>
  </tr>
</template>

<script>
// import Button from '../Button.vue'
import DriverActions from '../DriverActions.vue'

export default {
  components: {
    DriverActions,
  },
  props: {
    driver: Object,
    showInternalData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      additionalActions: [{
        name: 'Edit Driver',
        callback: 'toDriverForm',
        seprator: true
      }],
    }
  },
  methods: {
    toDriverForm() {
      this.$router.push({
        name: 'DriverForm',
        params: { driverId: String(this.driver.id) },
      })
    },
    statusString(value) {
      if (value) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    activeString(value){
      if(this.driver.validated){
        if (value) {
          return 'Yes'
        } else {
          return 'No'
        }
      } else {
        return 'No'
      }
    }
  },
  computed: {
    fullName() {
      return `${this.driver.user.first_name} ${this.driver.user.last_name}`
    },
    vendorDisplay() {
      if(this.driver.vendor.abbreviation == this.driver.vendor.name) {
        return this.driver.vendor.name
      } else {
        return `${this.driver.vendor.abbreviation} - ${this.driver.vendor.name}`
      }
    }
  },
}
</script>